import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
	HubConnectionBuilder,
} from '@aspnet/signalr'; // version 1.0.4

// action for user authentication and receiving the access_token
import * as actions from '../../actions';
import config from '../../configuration/configuration.js';

const startSignalRConnection = (connection, origin) => {
	if (origin !== undefined) {
		connection.start()
			.then(() => {
			})
			.catch(err => {
			});
	}
};

const NotificationHub = () => {
	const connection = useRef(null);
	const dispatch = useDispatch();
	const enqueueSnackbar = (...args) => dispatch(actions.enqueueSnackbar(...args));

	const NotificationRecieved = (info) => {
		enqueueSnackbar({
			message: info.title,
			options: {
				key: new Date().getTime() + Math.random(),
				variant: info.variant,
			},
		});
		dispatch(actions.FetchNotifications());
	};

	useEffect(() => {
		// register signalR after the user logged in
		if (connection.current === null && localStorage.getItem(config.TOKEN_KEY)) {
			const urlRoot = config.API_URL;
			const connectionHub = `${urlRoot}notificationhub?token=${localStorage.getItem(config.TOKEN_KEY)}`;

			// create the connection instance
			connection.current = new HubConnectionBuilder()
				.withUrl(connectionHub)
				.build();

			// event handlers, you can use these to dispatch actions to update your Redux store
			connection.current.on('NewNotification', NotificationRecieved);

			// re-establish the connection if connection dropped
			connection.current.onclose((error) => setTimeout(startSignalRConnection(connection.current, error), 5000));

			dispatch(actions.FetchNotifications());
			startSignalRConnection(connection.current, 'setup');
		}

		return (() => {
			if (connection.current) {
				connection.current.stop();
			}
		});
	}, []);

	return (
		null
	);
};

export default NotificationHub;
